import $axios from '../backend/vue-axios/axios.js'

const state = {
  verified: null,
  complete: null
}

const mutations = {
  setVerifiedEmail (state, payload) {
    state.verified = payload
  },
  passSet (state, payload) {
    state.complete = payload
  },
  clearState (state) {
    state.verified = null
    state.complete = null
  }
}

const getters = {
  isVerified (state) {
    return state.verified
  },
  isPasswordSet (state) {
    return state.complete
  }
}

const actions = {
  checkEmail ({commit, state}, payload) {
    var url = payload
    $axios.post(url.url, {email: url.email})
    .then((response) => {
      commit('setVerifiedEmail', response.data.msg)
    })
  },
  setNewPassword ({commit}, payload) {
    var url = payload
    $axios.post(url.url, {password: url.password, email: url.email, captchaToken: url.recaptchaToken})
    .then((response) => {
      commit('passSet', response.data.msg)
    })
  },
  resetState ({commit}) {
    commit('clearState')
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/resetPassword.js